require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-calculators-compare-roth-401-k-and-traditional-401-k-retirement-savings-plans.json") })
        }
      }, "path---es-calculators-compare-roth-401-k-and-traditional-401-k-retirement-savings-plans");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-calculators-compare-roth-401-k-and-traditional-401-k-retirement-savings-plans!./.cache/json/es-calculators-compare-roth-401-k-and-traditional-401-k-retirement-savings-plans.json
// module id = 2505
// module chunks = 231608221292675